//
// Module for Document Review - Index view
//
rs.module("content/system_/activity/documentreview/index",

    [],

    function () {

        // Initialize the module
        function initialize(lrsGridApi) {

            // On load, if a row is selected - scroll to ensure it is visible.
            if (lrsGridApi.agGridApi.getSelectedNodes().length != 0) {
                var firstSelectedRowIndex = lrsGridApi.agGridApi.getSelectedNodes()[0].rowIndex;
                lrsGridApi.agGridApi.ensureIndexVisible(firstSelectedRowIndex, 'middle');
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);